import axios from 'axios';
import { handleInterceptorResponseRequest, handleInterceptorResponseError, checkAppVersion, isTokenExpired } from './httpUtils';
import InitVm from '../services/init';
import Logger from '../services/logger';


const MyLogger = new Logger(
    {
        lingerMs: 0
    },
    null
);

let isRefreshingToken = false;
let pendingRequests = [];

const redirectToLogin = () => {
    //reject pending requests
    pendingRequests.forEach((req) => {
        req.reject();
    });
    pendingRequests = [];
    isRefreshingToken = false;
    localStorage.clear();
    window.location = '#/login';
};

// Function to add subscribers for token refresh
const subscribeTokenRefresh = (resolve, reject) => {
    pendingRequests.push({ resolve, reject });
};

// Notify all subscribers once a token is refreshed
const onTokenRefreshed = (newToken) => {
    pendingRequests.forEach((callback) => callback.resolve(newToken));
    pendingRequests = [];
};

// Function to refresh token
const handleTokenRefresh = async () => {
    isRefreshingToken = true;
    try {
        //get token
        const newToken = await new InitVm().refreshAccessToken();
        if (!newToken) {
            redirectToLogin();
        }
        // Update all clients with the new token — the email API is authed with the
        // same identity JWT (matches whise-mobile-ionic).
        client.defaults.headers.Authorization = `Bearer ${newToken}`;
        emailClient.defaults.headers.Authorization = `Bearer ${newToken}`;
        onTokenRefreshed(newToken); // Notify subscribers
    } catch (err) {
        MyLogger.error('Token refresh failed:', err);
        redirectToLogin();
    } finally {
        isRefreshingToken = false;
    }
};

const handleInterceptorRequestConfig = (config) => {
    checkAppVersion();
    if (isTokenExpired()) {
        if (!isRefreshingToken) {
            handleTokenRefresh();
        }
        // Wait for the token to be refreshed
        return new Promise((resolve, reject) => {
            subscribeTokenRefresh((newToken) => {
                config.headers.Authorization = `Bearer ${newToken}`;
                resolve(config);
            }, reject);
        });
    }
    const AccessToken = localStorage.getItem('AccessToken');

    if (AccessToken) {
        config.headers['Authorization'] = 'Bearer ' + AccessToken;
    }

    if (config.method === 'put' && config.params && config.params.correlationId) {
        config.headers['x-correlation-id'] = config.params.correlationId;
    }
    return config;
};

// Factory so every client (main API + email API) shares the same request/refresh
// logic and attaches the identity JWT — mirrors whise-mobile-ionic's createHttpClient.
const createHttpClient = (baseURL) => {
    const instance = axios.create({ baseURL });

    instance.interceptors.request.use(
        (config) => handleInterceptorRequestConfig(config),
        (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        (response) => handleInterceptorResponseRequest(response),
        (error) => handleInterceptorResponseError(error)
    );

    return instance;
};

// Main API client.
const client = createHttpClient(window.env?.REACT_APP_API_URL);

// Email/mail API client — authed with the same identity JWT via the shared
// request interceptor (no separate password-derived token).
export const emailClient = createHttpClient(window.env?.REACT_APP_EMAIL_API_URL);

export default client;
